import React, { createContext } from 'react';

const { Provider, Consumer } = createContext({});

const withContext = (Child) => (props) => (
    <Consumer>
        { (context) => <Child context={context} {...props} />}
    </Consumer>
);

export {
    Provider,
    Consumer,
    withContext,
};
